import {
  alpha,
  Dialog,
  DialogActions,
  DialogContent,
  styled,
  Typography,
} from '@mui/material';

import { Button } from 'theSource/components';

export const DIALOG_Z_INDEX = 1450;

export const DialogStyled = styled(Dialog)(({ theme }) => ({
  zIndex: DIALOG_Z_INDEX,
  '.MuiDialog-container': {
    position: 'absolute',
    left: 0,
    bottom: 0,
    minWidth: '100%',
    minHeight: `${theme.customSizes.postLoginDownloadPromptHeight}rem`,
    maxHeight: `${theme.customSizes.postLoginDownloadPromptHeight}rem`,
  },
  '.MuiPaper-root': {
    margin: 0,
    backgroundColor: theme.palette.primaryLight.main,
  },
}));

export const DialogActionsStyled = styled(DialogActions)({
  paddingRight: 24,
  paddingTop: 12,
  '.MuiSvgIcon-root': {
    height: '2.4rem',
    width: '2.4rem',
  },
});

export const DialogImageStyled = styled(DialogContent)(({ theme }) => ({
  padding: theme.spacing(8, 6),
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  backgroundColor: theme.palette.primaryLight.main,
}));

export const DialogContentBelowImageStyled = styled(DialogContent)(
  ({ theme }) => ({
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
    backgroundColor: theme.palette.common.white,
    minHeight: '10rem',
  })
);

export const CancelButtonStyled = styled(Button)(({ theme }) => ({
  color: theme.palette.primaryDark.main,
  paddingLeft: 5,
  '&:focus': {
    backgroundColor: alpha(theme.palette.primaryMedium.main, 0.2),
  },
  '.MuiTouchRipple-child': {
    backgroundColor: alpha(theme.palette.primaryMedium.main, 0.2),
  },
}));

export const DialogTitleStyled = styled(Typography)({
  textAlign: 'center',
  height: '6.2rem',
  wordBreak: 'break-word',
});

export const LogoStyled = styled('img')(({ theme }) => ({
  height: '100%',
  maxWidth: '100%',
  objectFit: 'contain',
  color: theme.palette.primaryDark.main,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));

export const DownloadInstructionsTypographyStyled = styled(Typography)({
  whiteSpace: 'pre-line',
  fontSize: '1.8rem',

  '& .MuiSvgIcon-root': {
    verticalAlign: 'bottom',
    color: '#0040DC',
    fontSize: '2rem',
  },
});
